/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-undef */
/* eslint-disable prefer-rest-params */
/* eslint-disable react/prop-types */
import React, { Suspense, Component, useEffect } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Routes,
  useLocation,
  Route,
} from "react-router-dom";
import { Oval } from "react-loader-spinner";
import { connect } from "react-redux";
import EventBus from "eventing-bus";
import { ROUTES } from "src/config/user-authorization";
import {
  getLogoutChannel,
  shouldSignOut,
} from "src/helpers/logout-channel";
import { Utility } from "src/helpers/utility";
import { BrandProvider } from "src/brands/brand-context";
import { getBrandLanguage } from "src/brands/brand-language";
import { bootIntercom } from "src/helpers/intercom";
import Analytics from "src/helpers/analytics";
import UnAuthenticated from "src/routes/un-authenticated";
import * as Sentry from "@sentry/react";
import ReactTooltip from "react-tooltip";
import i18n from "./i18n";
import { MiscCreators } from "./redux/actions/misc.actions";
import { UserCreators } from "./redux/actions/user.actions";
import { ConnectionsCreators } from "./redux/actions/connections.actions";
import { SEGMENT_KEY } from "./config";
import { getCountryCode } from "./web-services/user";

import "src/icons";

const AuthenticatedRoutes = React.lazy(
  () => import("./routes/authenticated-routes"),
);
const EventCancelScreen = React.lazy(
  () => import("./screens/event-cancel"),
);
const SSOScreen = React.lazy(() => import("./screens/sso"));
const SignInScreen = React.lazy(() => import("./screens/sign-in"));
const EventsSignInScreen = React.lazy(
  () => import("./screens/webinars/events-sign-in"),
);
const ForgotPasswordScreen = React.lazy(
  () => import("./screens/forgot-password"),
);
const ResetPasswordScreen = React.lazy(
  () => import("./screens/reset-password"),
);
const EventsForgotPasswordScreen = React.lazy(
  () => import("./screens/webinars/events-forgot-password"),
);
const EventsResetPasswordScreen = React.lazy(
  () => import("./screens/webinars/events-reset-password"),
);

// Public screens
const LandingScreen = React.lazy(() => import("./screens/landing"));
const ZoomScreen = React.lazy(() => import("./screens/zoom"));
const TuitionPayment = React.lazy(
  () => import("./screens/tuition-payment"),
);
const WebinarCookiesPage = React.lazy(
  () => import("./screens/webinar-cookies"),
);
const PaymentsScreen = React.lazy(() => import("./screens/payments"));
const MobilePaymentRedirectScreen = React.lazy(
  () => import("./screens/mobile-payment"),
);
const ScheduleAppointmentScreen = React.lazy(
  () => import("./screens/schedule-appointment"),
);
const EmailValidationScreen = React.lazy(
  () => import("./screens/email-validation"),
);
const UniversitySearchScreen = React.lazy(
  () => import("./screens/university-search"),
);
const UniversityRegisterScreen = React.lazy(
  () => import("./screens/university-register"),
);

// Webinar screens
const EventsLandingScreen = React.lazy(
  () => import("./screens/webinars/events-landing"),
);
const EventsCategoryScreen = React.lazy(
  () => import("./screens/webinars/events-category"),
);
const EventsSearchScreen = React.lazy(
  () => import("./screens/webinars/events-search"),
);
const EventsViewScreen = React.lazy(
  () => import("./screens/webinars/events-view"),
);
const EventsFaqScreen = React.lazy(
  () => import("./screens/webinars/events-faq"),
);
const EventsAboutScreen = React.lazy(
  () => import("./screens/webinars/events-about"),
);
const EventsSearchSchoolScreen = React.lazy(
  () => import("./screens/webinars/events-search-school"),
);
const EventsRegisterScreen = React.lazy(
  () => import("./screens/webinars/events-register"),
);

function PrivacyPolicyRedirect() {
  useEffect(() => {
    window.location.href =
      "https://www.cialfo.co/en-intl/privacy-policy-explore";
  }, []);
  return null;
}

class App extends Component {
  constructor(props) {
    super(props);

    const { locale } = props;

    i18n.changeLanguage(getBrandLanguage(locale));
  }

  componentDidMount() {
    this.sessionListener = EventBus.on(
      "session_expired",
      this.props.signOut,
    );

    // Call getMiscData if user is authenticated (including after SSO redirect)
    if (
      !window.location.href.includes("/sso") &&
      this.props.authToken
    ) {
      this.props.getMiscData();
    }

    document.body.classList.add(getOS());

    if (this.props.authToken) {
      const { user } = this.props;
      bootIntercom({ isAuthenticated: true, user });
      Analytics.shouldTrackUser(user);
      // Set Sentry user context for already authenticated users
      if (user) {
        this.setSentryUserContext(user);
      }
    } else {
      bootIntercom({ isAuthenticated: false });
      this._getCountryCode();
    }

    if (!this.channel) {
      this.channel = getLogoutChannel();
      this.channel.onmessage = msg => this.handleChannel(msg);
    }
    this.loadSegment();
  }

  componentDidUpdate(prevProps) {
    const { user, locale, authToken } = this.props;

    if (prevProps.locale !== locale) {
      i18n.changeLanguage(getBrandLanguage(locale));
    }

    // User logged out
    if (prevProps.authToken && !authToken) {
      window?.analytics?.reset();
      bootIntercom({ isAuthenticated: false });
      this.clearSentryUserContext();
      this._getCountryCode();
    }
    // User logged in
    else if (!prevProps.authToken && authToken) {
      this.props.getMiscData();
      bootIntercom({ isAuthenticated: true, user });
      Analytics.shouldTrackUser(user);
      if (user) {
        this.setSentryUserContext(user);
      }
    }
    // User data updated while logged in
    else if (authToken && prevProps.user !== user && user) {
      this.setSentryUserContext(user);
    }
  }

  setSentryUserContext = user => {
    Sentry.setUser({
      id: user.id?.toString(),
      email: user.email,
      username:
        user.first_name && user.last_name
          ? `${user.first_name} ${user.last_name}`
          : user.email,
      institute_type: user.institute_type,
      role: user.role?.name,
      company: user.company?.name,
      is_admin: user.is_admin,
    });
  };

  clearSentryUserContext = () => {
    Sentry.setUser(null);
  };

  loadSegment = () => {
    const { authToken, user } = this.props;

    window.addEventListener("load", () => {
      const segmentScript = document.getElementById("segment-script");

      if (segmentScript) {
        segmentScript.addEventListener("load", () => {
          if (window.analytics) {
            Analytics.load(SEGMENT_KEY);
          }
          if (authToken) {
            bootIntercom({ isAuthenticated: true, user });
          } else {
            bootIntercom({ isAuthenticated: false });
          }
        });
      }
    });
  };

  handleChannel = msg => {
    const { signOut, user } = this.props;
    if (shouldSignOut(msg, user?.id) && document.hidden) {
      signOut();
    }
  };

  _getCountryCode = () => {
    const { updateAppLocale } = this.props;
    getCountryCode()
      .then(response => {
        updateAppLocale(response.data);
      })
      .catch(error => {
        console.error(
          "Failed to get country code from geo-ip service:",
          error,
        );
        // Fallback to a default locale if geo-ip fails (e.g., due to CORS or network issues)
        // This prevents the app from breaking when the geo-ip service is unavailable
        updateAppLocale({ country_code: "US" }); // Default fallback
      });
  };

  render() {
    return (
      <Suspense
        fallback={
          <div className="flex justify-center items-center z-20 absolute inset-0">
            <Oval color="grey" height={50} width={50} />
          </div>
        }
      >
        <BrandProvider>
          <Router>
            <ModalSwitch {...this.props} />
          </Router>
          {/* Global Tooltips for generic usage */}
          <ReactTooltip id="table-cell-tooltip" />
          <ReactTooltip id="inline-tooltip" />
        </BrandProvider>
      </Suspense>
    );
  }
}

function getOS() {
  const { userAgent } = window.navigator;
  const { platform } = window.navigator;
  const macosPlatforms = [
    "Macintosh",
    "MacIntel",
    "MacPPC",
    "Mac68K",
  ];
  const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
  const iosPlatforms = ["iPhone", "iPad", "iPod"];
  let os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "macos";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "ios";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "windows";
  } else if (/Android/.test(userAgent)) {
    os = "android";
  } else if (!os && /Linux/.test(platform)) {
    os = "linux";
  }

  return os;
}

function ModalSwitch(props) {
  const location = useLocation();
  const background = location.state && location.state.background;
  const currentTab = location.state && location.state.currentTab;
  const includePastEvents =
    location.state && location.state.includePastEvents;

  const { authToken, partner } = props;
  const getNewConnectionCount = () => {
    const { getConnectionCounts } = props;
    const params = { user_type: "all" };
    return new Promise((resolve, reject) => {
      getConnectionCounts(params, resolve, reject);
    }).catch(e => {
      Utility.promiseCatch(e);
    });
  };

  useEffect(() => {
    const isLoggedInUni =
      authToken && partner && partner.institute_type === "University";
    if (location.pathname !== ROUTES.CONNECTIONS && isLoggedInUni) {
      getNewConnectionCount();
    }
  }, [location, partner, authToken]);

  return (
    <div className="h-full relative">
      <Routes location={background || location}>
        {/* SSO */}
        <Route path={ROUTES.SSO} element={<SSOScreen />} />

        {/* Public routes */}
        <Route
          path="/"
          element={<UnAuthenticated component={LandingScreen} />}
        />
        <Route path={ROUTES.ZOOM} element={<ZoomScreen />} />
        <Route
          path={ROUTES.TUITION_FEE}
          element={<TuitionPayment />}
        />
        <Route
          path={ROUTES.PRIVACY_POLICY}
          element={<PrivacyPolicyRedirect />}
        />
        <Route
          path={ROUTES.COOKIES_POLICY}
          element={<WebinarCookiesPage />}
        />
        <Route
          path={ROUTES.PAYMENT_DETAIL}
          element={<PaymentsScreen />}
        />
        <Route
          path={ROUTES.MOBILE_PAYMENT_REDIRECT}
          element={
            <UnAuthenticated
              component={MobilePaymentRedirectScreen}
            />
          }
        />
        <Route
          path={ROUTES.SCHEDULE_APPOINTMENT}
          element={
            <UnAuthenticated component={ScheduleAppointmentScreen} />
          }
        />
        <Route
          path={ROUTES.EMAIL_VALIDATED}
          element={
            <UnAuthenticated component={EmailValidationScreen} />
          }
        />
        <Route
          path={ROUTES.SEARCH_UNIVERSITY}
          element={
            <UnAuthenticated component={UniversitySearchScreen} />
          }
        />
        <Route
          path={ROUTES.REGISTER_UNIVERSITY}
          element={
            <UnAuthenticated component={UniversityRegisterScreen} />
          }
        />

        {/* Webinar browse routes — always accessible regardless of auth */}
        <Route
          path={ROUTES.WEBINARS}
          element={<EventsLandingScreen />}
        />
        <Route
          path={ROUTES.WEBINARS_CATEGORY_DETAIL}
          element={<EventsCategoryScreen />}
        />
        <Route
          path={ROUTES.WEBINARS_CATEGORY_SEARCH}
          element={<EventsSearchScreen />}
        />
        <Route
          path={ROUTES.WEBINARS_CATEGORY_EVENT_DETAIL}
          element={<EventsViewScreen />}
        />
        <Route
          path={ROUTES.WEBINARS_FAQ}
          element={<EventsFaqScreen />}
        />
        <Route
          path={ROUTES.WEBINARS_ABOUT}
          element={<EventsAboutScreen />}
        />
        <Route
          path={ROUTES.WEBINARS_SEARCH_SCHOOL}
          element={
            <UnAuthenticated component={EventsSearchSchoolScreen} />
          }
        />
        <Route
          path={ROUTES.WEBINARS_REGISTER}
          element={
            <UnAuthenticated component={EventsRegisterScreen} />
          }
        />

        {/* Authenticated catch-all / unauthenticated redirect */}
        {authToken && (
          <Route path="*" element={<AuthenticatedRoutes />} />
        )}

        {/* Auth routes (redirect to home if already logged in) */}
        <Route
          path={ROUTES.SIGN_IN}
          element={<UnAuthenticated component={SignInScreen} />}
        />
        <Route
          path={ROUTES.FORGOT_PASSWORD}
          element={
            <UnAuthenticated component={ForgotPasswordScreen} />
          }
        />
        <Route
          path={ROUTES.RESET_PASSWORD}
          element={
            <UnAuthenticated component={ResetPasswordScreen} />
          }
        />
        <Route
          path={ROUTES.WEBINARS_SIGN_IN}
          element={<UnAuthenticated component={EventsSignInScreen} />}
        />
        <Route
          path={ROUTES.WEBINARS_FORGOT_PASSWORD}
          element={
            <UnAuthenticated component={EventsForgotPasswordScreen} />
          }
        />
        <Route
          path={ROUTES.WEBINARS_RESET_PASSWORD}
          element={
            <UnAuthenticated component={EventsResetPasswordScreen} />
          }
        />

        {/* <Route
          path={ROUTES.WEBINARS_USER_UPDATE}
          element={
            <Navigate
              to={`${ROUTES.WEBINARS}${location.search}`}
              replace
            />
          }
        />
        <Route
          path={ROUTES.WEBINARS_MY_SESSIONS}
          element={
            <Navigate
              to={`${ROUTES.WEBINARS}${location.search}`}
              replace
            />
          }
        /> */}
        <Route
          path="*"
          element={
            <Navigate
              to={`${ROUTES.SIGN_IN}${location.search}`}
              replace
            />
          }
        />
      </Routes>
      {background && (
        <Routes>
          <Route
            path={ROUTES.CANCEL_EVENT}
            element={
              <EventCancelScreen
                currentTab={currentTab}
                includePastEvents={includePastEvents}
              />
            }
          />
        </Routes>
      )}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    authToken: state.user.authToken,
    user: state.user.data,
    partner: state.partner.data,
    locale: state.user.data
      ? state.user.data.locale
      : state.user.locale,
    hasPageLoadTransactionEnded:
      state.misc.hasPageLoadTransactionEnded,
  };
}

const mapDispatchToProps = {
  getMiscData: MiscCreators.getMiscDataRequest,
  signOut: () => UserCreators.logout(),
  updateAppLocale: () => UserCreators.updateAppLocale(),
  getConnectionCounts: ConnectionsCreators.hideCountsRequest,
  setHasPageLoadTransactionEnded:
    MiscCreators.setHasPageLoadTransactionEnded,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
